import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

interface StatusBadgeProps {
    status: string;
}

const STATUS_CLASS: Record<string, string> = {
    stable: 'statusStable',
    active: 'statusActive',
    beta: 'statusBeta',
    inactive: 'statusInactive',
    deprecated: 'statusDeprecated',
    revoked: 'statusRevoked',
};

/*
 * Color-coded pill badge for an endpoint/group lifecycle status (stable/beta/deprecated) or
 * a service principal status (active/inactive/revoked) — shared by both since the value
 * sets don't overlap.
 */
export function StatusBadge({ status }: StatusBadgeProps) {
    const variantClass = STATUS_CLASS[status];
    return <span className={classNames(styles.badge, variantClass ? styles[variantClass] : undefined)}>{status}</span>;
}
